import React from 'react';
import { connect } from 'react-redux';

import { toggleSpinner, updateMessages } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { updatePageMessages } from 'apps/auth/actions/messageAction';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { AUTH_CARD_CANCEL, AUTH_CARD_CONFIRM, AUTH_SEND_LINK } from 'apps/auth/constants/UrlConstants';
import { apiFetchFormData } from 'apps/auth/helpers/api';
import { logWarn } from 'apps/auth/helpers/clientLogger';

const NotFinishedTransactionsPopup = (props) => {
    const CANCEL_URL = `${AUTH_CARD_CANCEL}/${props.unconfirmedLinkId}`;

    const cancelAction = (e) => {
        e.preventDefault();
        props.toggleSpinner(true);
        props.popupRef.current?.close();
        apiFetchFormData(CANCEL_URL, {
            redirectUrl: {
                name: 'redirectUrl',
                value: `${AUTH_SEND_LINK}?from_source=cancel-card-verification`,
            },
        })
            .then((json) => {
                if (json) {
                    if (json.redirectTo) {
                        window.location.href = json.redirectTo;
                        return;
                    }
                    if (json.messageBodyMessages) {
                        props.updateMessages(json.messageBodyMessages);
                    }
                    if (json.messages) {
                        props.updatePageMessages(json.messages);
                    }
                    if (json.extra) {
                        props.addExtras(json.extra);
                    }
                    props.toggleSpinner(false);
                }
            })
            .catch((error) => {
                logWarn(error);
                props.toggleSpinner(false);
            });
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={<DangerouslyHtml dangerouslyHtml={props.unconfirmedLinkDisclaimerText} />}>
            <PopupButton
                href={CANCEL_URL}
                iconName="arrow-forward"
                text={<DangerouslyHtml dangerouslyHtml={props.unconfirmedLinkCancel} />}
                onClick={(e) => cancelAction(e)}
            />
            <PopupButton href={`${AUTH_CARD_CONFIRM}/${props.unconfirmedLinkId}/preview`} iconName="arrow-back" text={props.unconfirmedLinkNow} />
        </SimplePopup>
    );
};
const mapStateToProps = (state) => {
    return {
        unconfirmedLinkId: state.extra.unconfirmedLinkId,
        unconfirmedLinkDisclaimerText: state.messages.pageMessages.unconfirmedLinkDisclaimerText,
        unconfirmedLinkNow: state.messages.pageMessages.unconfirmedLinkNow,
        unconfirmedLinkCancel: state.messages.pageMessages.unconfirmedLinkCancel,
    };
};
export default connect(mapStateToProps, {
    toggleSpinner,
    updateMessages,
    updatePageMessages,
    addExtras,
})(NotFinishedTransactionsPopup);
